import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { UI_TEXT } from '../config/gameConfig';

const LevelTransition = ({ onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(onComplete, 4000);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black relative overflow-hidden">
      <div className="text-center z-10">
        <motion.div
          className="relative w-32 h-40 mx-auto mb-8"
          animate={{
            rotate: [0, -10, 10, -10, 0],
            scale: [1, 1.1, 1.2, 1.5, 20],
            opacity: [1, 1, 1, 1, 0]
          }}
          transition={{
            duration: 3.5,
            times: [0, 0.2, 0.4, 0.8, 1],
            ease: "easeInOut"
          }}
        >
          {/* Flask Body */}
          <svg viewBox="0 0 100 120" className="w-full h-full drop-shadow-[0_0_15px_rgba(6,182,212,0.8)]">
            <path
              d="M30,0 L70,0 L70,40 L90,110 C92,115 88,120 80,120 L20,120 C12,120 8,115 10,110 L30,40 L30,0 Z"
              fill="rgba(255,255,255,0.1)"
              stroke="#06b6d4"
              strokeWidth="2"
            />
            {/* Liquid */}
            <motion.path
              d="M12,110 L30,45 L70,45 L88,110 C90,115 86,118 80,118 L20,118 C14,118 10,115 12,110 Z"
              fill="#06b6d4"
              animate={{ fill: ["#06b6d4", "#ef4444", "#ffffff"] }}
              transition={{ duration: 3 }}
            />
            {/* Bubbles */}
            <motion.circle
              cx="40"
              cy="80"
              r="3"
              fill="white"
              animate={{ y: -40, opacity: 0 }}
              transition={{ repeat: Infinity, duration: 1 }}
            />
            <motion.circle
              cx="60"
              cy="90"
              r="2"
              fill="white"
              animate={{ y: -50, opacity: 0 }}
              transition={{ repeat: Infinity, duration: 1.2, delay: 0.5 }}
            />
          </svg>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="text-cyan-500 font-mono tracking-widest"
        >
          {UI_TEXT.transition.message}
        </motion.div>
      </div>

      {/* Explosion Flash */}
      <motion.div
        className="absolute inset-0 bg-white"
        initial={{ opacity: 0 }}
        animate={{ opacity: [0, 0, 1] }}
        transition={{ duration: 3.5, times: [0, 0.9, 1] }}
      />
    </div>
  );
};

export default LevelTransition;